import { Injectable } from '@angular/core';
import { TeamService } from '../../api/services/team.service';
import { map } from "rxjs/operators";
import { FindFilter } from "../../api/models/find-filter";
import { NdmsSafeSubscriber } from 'projects/shared/core/interfaces/ndms-safe-subscriber';
import { ResponderService } from '../../api/services/responder.service';
import { AdminOfficerModel } from '../../api/models/admin-officer-model';

@Injectable()
export class TeamsService extends NdmsSafeSubscriber {

  constructor(private apiService: TeamService, private _responderService: ResponderService) { super(); }

  searchTeams(searchCriteria: any) {
    let params: FindFilter = {};
    params.findKeys = {
      TeamLevel: searchCriteria.TeamLevel ? searchCriteria.teamLevel.id : null,
      page: searchCriteria.pageNumber,
      pageSize: searchCriteria.pageSize,
      TeamType: searchCriteria.teamType ? searchCriteria.teamType.id : null,
      TeamRegion: searchCriteria.region ? searchCriteria.region.id : null,
      TeamName: searchCriteria.teamName,
      showAll: searchCriteria.showAll || false
    };

    return this.apiService.FindInDomain(params).pipe(map((viewModel: any) => {
      return viewModel;
    }));
  }

  isCoreActiveNdmsTeam(teamId: number) {
    return new Promise<boolean>((resolve, reject) => {
      this.safeSubscribe(this.apiService.FindInDomain({
        findKeys: {
          "Id": teamId.toString(),
          "IsCoreActiveNdmsTeam": "true"
        }
      }),
        (data: any[]) => resolve(data && data.length > 0),
        error => reject(error));
    });
  }

  getTeamAdministrativeOfficers(teamId: number) {
    return new Promise<AdminOfficerModel[]>((resolve, reject) => {
      this.safeSubscribe(this._responderService.GetTeamAdministrativeOfficers(teamId),
        data => resolve(data),
        error => reject(error));
    });
  }
}